/* eslint-disable */

import React from "react";
import { renderReact } from "../src/lib/ssrHydrator";
import ArticleSearchContainer from "../src/ArticleSearchForm/containers/ArticleSearchContainer";
import FormItemsConteiner from "../src/ArticleSearchForm/containers/FormItemsContainer";
import { CompanyPCArticleListWrapper } from "./CompanyPCArticleList";
import PagingZone from "../src/ArticleSearchForm/components/shared/pc/PagingZone";
import Form from "../src/ArticleSearchForm/components/shared/pc/Form";
import DetailSearchForm from "../src/ArticleSearchForm/components/shared/pc/DetailSearchForm";
import Loader from "../src/ArticleSearchForm/components/shared/common/Loader";
import ErrorBoundary from "../src/ErrorBoundary/error_notifier";

function CompanyPCArticleSearchForm(props) {
  return (
    <ErrorBoundary>
      <ArticleSearchContainer.Provider
        initialState={{ ...props, requestFromSp: false }}
      >
        <FormItemsConteiner.Provider initialState={{ items: props.items }}>
          <PagingZone>
            <CompanyPCArticleListWrapper
              company_name={props.company_name}
              company_name_ja={props.company_name_ja}
            />
          </PagingZone>
          <Form />
          <DetailSearchForm />
          <Loader />
        </FormItemsConteiner.Provider>
      </ArticleSearchContainer.Provider>
    </ErrorBoundary>
  );
}

export default renderReact(
  "CompanyPCArticleSearchForm",
  CompanyPCArticleSearchForm
);
